import { useEffect, useState } from "react";
import useTranslation from "../../hooks/i18n/useTranslation";
import "./Select.css";

/**
 * Generic Select component that works consistently with all form types
 */
const Select = ({
  items = [],
  selectedItem = "",
  placeholder,
  name = "",
  onChange = () => {},
  disable = false,
  error = null,
  className = "",
  id,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
}) => {
  const [selectedItemInternal, setSelectedItemInternal] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (
      selectedItem === undefined ||
      selectedItem === null ||
      selectedItem === ""
    ) {
      setSelectedItemInternal("");
      return;
    }

    if (typeof selectedItem === "object" && selectedItem !== null) {
      setSelectedItemInternal(selectedItem.value);
      return;
    }

    const matchingItem = items.find(item => {
      const itemValue = typeof item === "object" ? item.value : item;

      return (
        String(itemValue).toLowerCase() === String(selectedItem).toLowerCase()
      );
    });

    setSelectedItemInternal(
      matchingItem
        ? typeof matchingItem === "object"
          ? matchingItem.value
          : matchingItem
        : selectedItem
    );
  }, [selectedItem, items]);

  const handleSelectChange = event => {
    const newValue = event.target.value;
    setSelectedItemInternal(newValue);

    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          name,
          value: newValue === "" ? "" : newValue,
        },
      });
    }
  };

  const getOptionLabel = item => {
    if (typeof item === "object" && item !== null) {
      return item.label || item.value;
    }
    return item;
  };

  const getOptionValue = item => {
    if (typeof item === "object" && item !== null) {
      return item.value;
    }
    return item;
  };

  return (
    <div
      className={`App-select-parent ${className} ${error ? "error" : ""} ${
        disable ? "disabled" : ""
      }`}
    >
      <select
        id={id}
        name={name}
        value={selectedItemInternal}
        onChange={handleSelectChange}
        className={`App-select ${
          !selectedItemInternal ? "App-select-placeholder" : ""
        } ${disable ? "disabled" : ""}`}
        disabled={disable}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
      >
        {placeholder && <option value="">{placeholder || t("54")}</option>}
        {items.map((item, index) => (
          <option
            key={index}
            className="App-select-option"
            value={getOptionValue(item)}
          >
            {getOptionLabel(item)}
          </option>
        ))}
      </select>
      {error && (
        <div className="error-message" id={`${id}-error`} role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default Select;
